import styled from 'styled-components';
var Fieldset = styled.fieldset.withConfig({
  displayName: "Fieldset",
  componentId: "mavf8v-0"
})(["border:0;margin:0;min-width:0;padding:0;"]);
export default Fieldset;